// @ts-nocheck

import palette from '../palette';

export const ListItem = {
  Label: {
    color: palette.white,
  },
  SeeAllRow: {
    backgroundColor: palette.bluegrey850,
  },
  Row: {
    activeBackgroundColor: palette.bluegrey700,
    expandedRowBackgroundColor: palette.sublistitemeven,
    expandedRowOddBackgroundColor: palette.sublistitemodd,
  },
  CollapseArrow: {
    expanded: {
      stroke: palette.white,
    },
    shrinkt: {
      stroke: palette.neutralgrey350,
    },
  },
};

export const SportsMenuListItem = {
  backgroundColor: palette.bluegrey900,
  arrowColor: palette.neutralgrey500,
  active: {
    backgroundColor: palette.bluegrey800,
  },
  separatorColor: palette.bluegrey800,
  extended: {
    backgroundColor: '#1F222E',
  },
  hoverColor: palette.bluegrey850,
};

export const List = {
  backgroundColor: palette.bluegrey850,
  Title: {
    color: palette.bluegrey200,
  },
  ListItems: {
    before: {
      backgroundColor: palette.bluegrey850,
    },
    rightArrow: {
      backgroundGradient: `linear-gradient(
        to right,
        ${palette.bluegrey800},
        ${palette.bluegrey800},
        ${palette.bluegrey800},
        ${palette.bluegrey850},
        ${palette.bluegrey850},
        ${palette.bluegrey850}
      )`,
    },
    oddDepth: {
      oddPosition: {
        backgroundGradient: palette.sportsactive,
      },
      evenPosition: {
        backgroundGradient: palette.sports,
      },
    },
    evenDepth: {
      oddPosition: {
        backgroundGradient: palette.sportsactive,
      },
      evenPosition: {
        backgroundGradient: palette.sports,
      },
    },
  },
};

export const TopActionLine = {
  Label: {
    color: palette.white,
  },
  Button: {
    color: palette.white,
    backgroundColor: palette.bluegrey850,
  },
};

export const SearchInput = {
  backgroundColor: palette.bluegrey900,
  placeholderColor: '#71747E',
  color: palette.white,
  highlightColor: palette.bluegrey500,
  light: {
    backgroundColor: palette.white,
    color: palette.black,
  },
};

export const SearchSuggestion = {
  highlightBackgroundColor: palette.yellowwinamax450,
  backgroundColor: palette.bluegrey800,
  color: palette.white,
};

export const SearchResults = {
  color: palette.white,
  categoriesColor: palette.neutralgrey200,
  categoriesBackgroundColor: palette.bluegrey900,
  liveMatch: {
    backgroundColor: palette.yellowwinamax450,
    labelColor: palette.black,
  },
};

export const DefaultSearchRowResult = {
  backgroundGradient: palette.sports,
  titleColor: palette.white,
  startDateColor: palette.bluegrey400,
  separatorColor: palette.white,
  breadcrumbsColor: palette.neutralgrey400,
  rowColor: palette.white,
};
